module.exports = "/fonts/nucleo.eot?03ef1918e505c3e3471f9369ef7a638f";